/* js/pages/ParcoursMenuPage.svelte generated by Svelte v3.46.4 */
import {
	HtmlTag,
	SvelteComponent,
	append,
	attr,
	create_component,
	destroy_component,
	destroy_each,
	detach,
	element,
	init,
	insert,
	listen,
	mount_component,
	safe_not_equal,
	space,
	src_url_equal,
	text,
	transition_in,
	transition_out
} from "svelte/internal";

import Header from '../components/Header.svelte';
import { db } from '../Db';
import { appRouter } from '../appRouter.js';
import { Ripple } from 'svelte-mui';
import HyperButton from '../components/HyperButton.svelte';
import ShareButton from '../components/ShareButton.svelte';
import computeUrl from '../url';

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[4] = list[i];
	return child_ctx;
}

// (48:4) {#each parcoursArray as parcours}
function create_each_block(ctx) {
	let div1;
	let img;
	let img_src_value;
	let t0;
	let div0;
	let t1_value = /*parcours*/ ctx[4].title + "";
	let t1;
	let t2;
	let mounted;
	let dispose;

	function click_handler_1() {
		return /*click_handler_1*/ ctx[3](/*parcours*/ ctx[4]);
	}

	return {
		c() {
			div1 = element("div");
			img = element("img");
			t0 = space();
			div0 = element("div");
			t1 = text(t1_value);
			t2 = space();
			attr(img, "class", "cover-event svelte-1g7rrnf");
			if (!src_url_equal(img.src, img_src_value = /*parcours*/ ctx[4].media.button_image)) attr(img, "src", img_src_value);
			attr(img, "alt", "");
			attr(div0, "class", "description svelte-1g7rrnf");
			attr(div1, "class", "grid-element event-card svelte-1g7rrnf");
		},
		m(target, anchor) {
			insert(target, div1, anchor);
			append(div1, img);
			append(div1, t0);
			append(div1, div0);
			append(div0, t1);
			append(div1, t2);

			if (!mounted) {
				dispose = listen(div1, "click", click_handler_1);
				mounted = true;
			}
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;
		},
		d(detaching) {
			if (detaching) detach(div1);
			mounted = false;
			dispose();
		}
	};
}

function create_fragment(ctx) {
	let header;
	let t0;
	let div1;
	let div0;
	let ripple;
	let t1;
	let img;
	let img_src_value;
	let t2;
	let sharebutton;
	let t3;
	let div6;
	let div2;
	let t4;
	let h1;
	let br0;
	let t6;
	let h2;
	let t8;
	let br1;
	let t9;
	let div4;
	let div3;
	let t10;
	let br2;
	let br3;
	let t11;
	let html_tag;
	let raw_value = /*accueilParcoursContent*/ ctx[1].html + "";
	let t12;
	let div5;
	let current;
	let mounted;
	let dispose;
	header = new Header({ props: { title: "Les parcours" } });
	ripple = new Ripple({ props: { center: true } });
	sharebutton = new ShareButton({ props: { url: computeUrl() } });
	let each_value = /*parcoursArray*/ ctx[0];
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	return {
		c() {
			create_component(header.$$.fragment);
			t0 = space();
			div1 = element("div");
			div0 = element("div");
			create_component(ripple.$$.fragment);
			t1 = space();
			img = element("img");
			t2 = space();
			create_component(sharebutton.$$.fragment);
			t3 = space();
			div6 = element("div");
			div2 = element("div");
			t4 = space();
			h1 = element("h1");
			h1.textContent = "Les parcours";
			br0 = element("br");
			t6 = space();
			h2 = element("h2");
			h2.textContent = "Parcours actifs";
			t8 = space();
			br1 = element("br");
			t9 = space();
			div4 = element("div");
			div3 = element("div");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			t10 = space();
			br2 = element("br");
			br3 = element("br");
			t11 = space();
			html_tag = new HtmlTag();
			t12 = space();
			div5 = element("div");
			if (!src_url_equal(img.src, img_src_value = "/_icons/info.svg")) attr(img, "src", img_src_value);
			attr(div0, "class", "fab-button small bottom-left box-shadow");
			attr(div1, "class", "footer");
			attr(div2, "class", "headspacer");
			attr(div3, "class", "grid-container grid-container--fill");
			attr(div4, "class", "grid-group-wrapper");
			html_tag.a = t12;
			attr(div5, "class", "footerspacer");
			attr(div6, "class", "column");
		},
		m(target, anchor) {
			mount_component(header, target, anchor);
			insert(target, t0, anchor);
			insert(target, div1, anchor);
			append(div1, div0);
			mount_component(ripple, div0, null);
			append(div0, t1);
			append(div0, img);
			append(div1, t2);
			mount_component(sharebutton, div1, null);
			insert(target, t3, anchor);
			insert(target, div6, anchor);
			append(div6, div2);
			append(div6, t4);
			append(div6, h1);
			append(div6, br0);
			append(div6, t6);
			append(div6, h2);
			append(div6, t8);
			append(div6, br1);
			append(div6, t9);
			append(div6, div4);
			append(div4, div3);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(div3, null);
			}

			append(div6, t10);
			append(div6, br2);
			append(div6, br3);
			append(div6, t11);
			html_tag.m(raw_value, div6);
			append(div6, t12);
			append(div6, div5);
			current = true;

			if (!mounted) {
				dispose = listen(div0, "click", /*click_handler*/ ctx[2]);
				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (dirty & /*appRouter, parcoursArray*/ 1) {
				each_value = /*parcoursArray*/ ctx[0];
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(div3, null);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value.length;
			}
		},
		i(local) {
			if (current) return;
			transition_in(header.$$.fragment, local);
			transition_in(ripple.$$.fragment, local);
			transition_in(sharebutton.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(header.$$.fragment, local);
			transition_out(ripple.$$.fragment, local);
			transition_out(sharebutton.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(header, detaching);
			if (detaching) detach(t0);
			if (detaching) detach(div1);
			destroy_component(ripple);
			destroy_component(sharebutton);
			if (detaching) detach(t3);
			if (detaching) detach(div6);
			destroy_each(each_blocks, detaching);
			mounted = false;
			dispose();
		}
	};
}

function instance($$self) {
	const parcoursArray = db.getAllParcours().slice().reverse();
	const accueilParcoursContent = db.accueilParcoursContent;
	const click_handler = () => appRouter.show("/a_propos");
	const click_handler_1 = parcours => appRouter.show(`/parcours/${parcours.slug}`);
	return [parcoursArray, accueilParcoursContent, click_handler, click_handler_1];
}

class ParcoursMenuPage extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default ParcoursMenuPage;